const TOTAL_PERCENTAGE = 100;
const TOTAL_PERCENTAGE_TOLERANCE = 2;

export const normalizePercentages = (values: number[]) => {
    const sanitizedValues = values.map(value =>
        Number.isFinite(value) ? Math.max(0, value) : 0
    );
    const total = sanitizedValues.reduce((sum, value) => sum + value, 0);

    if (
        total <= 0
        || Math.abs(total - TOTAL_PERCENTAGE) > TOTAL_PERCENTAGE_TOLERANCE
    ) {
        return sanitizedValues;
    }

    return sanitizedValues.map(value => value / total * TOTAL_PERCENTAGE);
};

export const getRemainingPercentage = (values: number[]) =>
    Math.max(
        0,
        TOTAL_PERCENTAGE - normalizePercentages(values)
            .reduce((sum, value) => sum + value, 0),
    );
